import { render } from "./pastWays.vue?vue&type=template&id=3cb26822&scoped=true&ts=true"
import script from "./pastWays.vue?vue&type=script&lang=ts"
export * from "./pastWays.vue?vue&type=script&lang=ts"

import "./pastWays.vue?vue&type=style&index=0&id=3cb26822&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb26822"]])

export default __exports__